import { render, staticRenderFns } from "./softwareDeatil.vue?vue&type=template&id=0baa78e0&scoped=true&"
import script from "./softwareDeatil.vue?vue&type=script&lang=js&"
export * from "./softwareDeatil.vue?vue&type=script&lang=js&"
import style0 from "./softwareDeatil.vue?vue&type=style&index=0&id=0baa78e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baa78e0",
  null
  
)

export default component.exports